import {
  getChatsOpen,
  setCanSetActiveModels,
  setIsEditingStatus,
  setMaximizedChat,
  setParentMessageId,
  setUserInteracted,
  toggleFullWidthMode,
} from "../../../../store/one-query/chatsSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import SignalRService from "../../../one-query/services/SignalRService";
import React, { useEffect, useState, useRef, useCallback, memo } from "react";
import UserQuestion from "./UserQuestion";
import "./Models.css";
import { AttachmentPayload, LastActiveVersion } from "../../../../Types";
import {
  addChatModelMessageAsync,
  addEditAndReplayChatModelAsync,
  appendReplyToChatModelMessage,
  replaceImageURL,
  setIsEditing,
  setIsRegenerating,
  updateModelEditIndex,
  updateModelReplyIndex,
  updatePlaceOfMessage,
} from "../../../../store/one-query/ChatModelSlice";
import {
  ChatModelState,
  MessageType,
  ModelsCompany,
  ModelsNamesCompany,
  TouchToleranceX,
  TouchToleranceY,
  dataReplyType,
  modelNames,
} from "../../../../Helper";
import { conversationsActions } from "../../../../store/one-query/conversationSlice";
import { useParams } from "react-router-dom";
import ResponseLoading from "./ResponseLoading";
import StreamingUserQuestion from "./StreamingUserQuestion";
import StreamingChatResponse from "./StreamingChatResponse";
import "./Models.css";
import StopResponse from "./StopResponse";
import ReturnVersionModel from "./ReturnVersionModel";
import { Dropdown } from "react-bootstrap";
import ExpandIcon from "../../../../Custom-imeges/ExpandIcon";
import ArrowDown from "../../../../Custom-imeges/ArrowDown";
import { getBaseUrl } from "../../../ImageSuite/Helper";
import { Box, Typography } from "@mui/material";
import { RemoveOutlined } from "@mui/icons-material";

const miniMaxContainerStyle={
      position: "relative",
      p:0.5,
      display:"grid",
      placeItems:"center",
      borderRadius:"50%",
      mr:-0.5,
      ":hover":{
        backgroundColor:"var(--M-background90)",
      }
    }

const minMaxToolTipHoverStyleContainer={
     width: "max-content",
     p:"8px 12px",
     borderRadius: "4px",
     backgroundColor:"var(--A_background73)",
     position: "absolute",
     top:"150%",
     right:"0%",
     zIndex: 100,
     "&::before": {
       content: '""',
       position: "absolute",
       top: "-10px",
       right: "5px",
       width: "0",
       height: "0",
       borderLeft: "8px solid transparent",
       borderRight: "8px solid transparent",
       borderBottom: `12px solid var(--A_background73)`,
       
    }
  }
interface Prompt {
  currentQuery: string;
  setQuery: (q: string) => void;
  index: number;
  page: string;
  versionName: any;
  versionId: string;
  modelNameFromParent: string;
  modelCompanyName: string;
  attachmentFileData?: { name: string, extension:string, type: string ,canDownload:boolean,url:string};
  onModelIsFinished:(version:string,isFinished:boolean)=>void;
  isActiveChat:boolean;
  setActiveChat:(index:number)=>void;
  emptyAttachmentFile:()=>void
}

interface MessageDataType {
  id: string;
  version: string;
}
const ChatModel = memo(({
  currentQuery,
  setQuery,
  index,
  page,
  versionName,
  versionId,
  modelNameFromParent,
  modelCompanyName,
  attachmentFileData,
  onModelIsFinished,
  isActiveChat,
  setActiveChat,
  emptyAttachmentFile
}: Prompt) => {
  const [defaultAnnonyVersion, setDefaultAnnonyVersion] = useState<string>("");
  const [hoverExpandChat, setHoverExpandChat] = useState<boolean>(false);
  const selectedOptionsStore = useAppSelector(
    (state) => state.ChatsState.selectedOptions
  );
  const isUserInteracted = useAppSelector(
    (state) => state.ChatsState.isUserInteracted
  );
  const newConversation = useAppSelector(
    (state) => state.ChatsState.newConversation
  );
  const disabledVersions = useAppSelector((s) => s.ChatsState.disabledVersions);
  const isFullWidth = useAppSelector((state) => state.ChatsState.fullWidthMode);
  const [selectedModelVersion, setSelectedModelVersion] = useState<string>("");
  const selectedColumns = useAppSelector((state) => state.ChatsState.chatsNum);
  const [defaultVersion, setDefaultVersion] = useState<string>("");
  const ChatsState = useAppSelector((state) => state.ChatsState);
  const { id } = useParams<{ id: string }>();
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const [isFinished, setIsFinished] = useState(false);
  const [response, setResponse] = useState("");
  const dispatch = useAppDispatch();
  const conversationVersionModels = useAppSelector(
    (state) => state.conversationVersion.data
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const modelState = useAppSelector((s) => s.chatModel.chatModelData);
  const [company, setCompany] = useState(modelCompanyName);
  const [currentModelName, setCurrentModelName] = useState(modelNameFromParent);
  const [imageGeneration,setImageGeneration]=useState<{imageURL:string,messageType:number}>({imageURL:"",messageType:0});
  const lastActiveModelsVersions = useAppSelector(
    (s) => s.Conversations.lastActiveModels
  );
  const [lastActiveVersion, setLastActiveVersion] = useState<LastActiveVersion>(
    { id: "", name: "", version: "" }
  );
  const [messageType, setMessageType] = useState<any>();
  const activeConversationId = useAppSelector(
    (s) => s.Conversations.activeConversationId
  );
  const isEditingStatus = useAppSelector((s) => s.ChatsState.isEditing);
  const currentObj = useAppSelector((s) => s?.ChatsState?.currentObj);
  const isSubscribed = useAppSelector((s) => s.User.isSubscribed);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [prompt, setPrompt] = useState("");
  const maximizedChat = useAppSelector((s) => s.ChatsState.maximizedChat);
  const ParentMessageId = useAppSelector((s) => s.ChatsState.ParentMessageId);
  const [messageData, setMessageData] = useState<MessageDataType>({
    id: "",
    version: "",
  });
   const isGenerateImage = useAppSelector((s) => s.ChatsState.isGenerateImage); 
  const darkMode=useAppSelector((s) => s.User.darkMode);
  const User = useAppSelector((s) => s.User);
  const scrollDevRef = useRef<HTMLDivElement>(null);
  const [startPoint, setStartPoint] = useState({ x: 0, y: 0})
  const [endPoint, setEndPoint] = useState({ x: 0, y: 0})
  const [attachmentFileUploaded, setAttachmentFileUploaded] = useState<AttachmentPayload>({fileName:"",blobUrl:"",type:"",canDownload:false});
  // Chick if it the first render to display the conversation at the bottom
  const Messages = ChatsState.displayConAtBottom ? [...modelState].reverse() : modelState;
 useEffect(()=>{
  if(attachmentFileData){
    setAttachmentFileUploaded({ fileName:attachmentFileData?.name+"."+attachmentFileData?.extension,type:attachmentFileData?.type,canDownload:attachmentFileData.canDownload,blobUrl:attachmentFileData.url})
  }
 },[attachmentFileData])
  useEffect(() => {
    if (currentQuery && currentQuery.length > 0) {
      if (isFullWidth && maximizedChat) {
        if (maximizedChat.versionName === selectedModelVersion) {
          setPrompt(currentQuery);
        }
      } else {
        setPrompt(currentQuery);
      }
    }
  }, [currentQuery]);

  useEffect(() => {
    if (lastActiveModelsVersions?.length > 0) {
      setLastActiveVersion(lastActiveModelsVersions[index]);
    } else {
      setLastActiveVersion({ id: "", name: "", version: "" });
    }
  }, [lastActiveModelsVersions, index]);

  useEffect(() => {
    const defaultObjModel = findDefaultChatModelObjInAnnon();
    if (defaultObjModel) {
      setDefaultAnnonyVersion(defaultObjModel.id);
    }
  }, [currentModelName]);

  const handleSetFullWidthModal = (chatName: string) => {
    dispatch(toggleFullWidthMode(chatName));
    setHoverExpandChat(false)
    handleSetMaxModalData();
  };

  const handleSetMaxModalData = () => {
    dispatch(
      setMaximizedChat({
        versionId: versionId,
        versionName: selectedModelVersion,
      })
      );
  };

  useEffect(()=> {
    if(isFullWidth){
      handleSetMaxModalData();
    }
  },[versionId])

  const miniChat = (chatName?: string) => {
    const targetChatName = chatName || `${currentModelName}${index}`;
      setHoverExpandChat(false)
    dispatch(toggleFullWidthMode(targetChatName));
    dispatch(setMaximizedChat(null));
  };

  // get first object in each model
  let firstObjInChatModel = conversationVersionModels?.find(
    (obj: any) =>
      obj?.name?.toLowerCase() === currentModelName?.toLowerCase() &&
      obj?.isDefault
  );
   let firstObjInChatModelInAnnon = conversationVersionModels?.find(
     (obj: any) =>
       obj?.name?.toLowerCase() === currentModelName?.toLowerCase() &&
       obj?.isDefault &&
       obj?.allowAnnonymous
   );
  // set default versions of annonymous page

  // toggle Dropdown of company selector
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  //get the company name of the model chat
  const getCompanyNameByModelName = (mName: string) => {
    return ModelsNamesCompany[mName];
  };

  // update model and model company name
  useEffect(() => {
    setCurrentModelName(modelNameFromParent);
    const companyName = getCompanyNameByModelName(
      currentModelName?.toLowerCase()
    );
    setCompany(companyName);
  }, [currentModelName, lastActiveVersion, modelNameFromParent]);

  // get lastActiveVersion if found
  useEffect(() => {
    if (id && currentModelName && !newConversation) {
      if (
        lastActiveVersion &&
        lastActiveVersion.name?.toLowerCase() ===
          currentModelName?.toLowerCase()
      ) {
        const versionObj = conversationVersionModels?.find(
          (obj) => obj.id === lastActiveVersion.id
        );
        if (versionObj) {
          setDefaultVersion(versionObj.id);
        }
      } else {
        const defaultObjModel = findDefaultChatModelObj();
        if (defaultObjModel) {
          setDefaultVersion(defaultObjModel.id);
        }
      }
    }
  }, [lastActiveVersion, currentModelName]);

  useEffect(() => {
    if (newConversation) {
      if (currentModelName) {
        const defaultObjModel = findDefaultChatModelObj();
        if (defaultObjModel) {
          setDefaultVersion(defaultObjModel.id);
        }
      }
      setQuery("");
      setPrompt("");
      setResponse("");
    }
  }, [newConversation, currentModelName]);
  
 const findDefaultChatModelObjInAnnon = () => {
   // Get all default versions for the current model
   const modelVersions = conversationVersionModels?.filter((obj) => {
     return (
       obj?.name?.toLowerCase() === currentModelName?.toLowerCase() &&
       obj?.isDefault &&!obj.isPro&&
       obj.allowAnnonymous
     );
   });
   if (modelVersions) {
     for (const version of modelVersions) {
       const isDisabled = ChatsState.disabledVersions.some(
         (disableObj) => disableObj === version.id
       );
       if (!isDisabled) {
         return version;
       }
     }
   }
   const availableVersions = conversationVersionModels?.filter((obj) => {
     return (
       obj?.name?.toLowerCase() === currentModelName?.toLowerCase() &&
       !obj?.isPro &&
       obj.allowAnnonymous
     );
   });
   // Iterate over the available versions and return the first non-disabled one
   if (availableVersions) {
     for (const version of availableVersions) {
       const isDisabled = ChatsState.disabledVersions.some(
         (disableObj) => disableObj === version.id
       );
       if (!isDisabled) {
         return version;
       }
     }
   }
   // If no non-disabled version is found, return undefined
   return undefined;
 };


  const findDefaultChatModelObj = () => {
    // Get all default versions for the current model
    const modelVersions = conversationVersionModels?.filter((obj) => {
      return isSubscribed
        ? obj?.name?.toLowerCase() === currentModelName?.toLowerCase() &&
            obj?.isDefault
        : obj?.name?.toLowerCase() === currentModelName?.toLowerCase() &&
            !obj?.isPro &&
            obj?.isDefault;
    });
    if (modelVersions) {
      for (const version of modelVersions) {
        const isDisabled = ChatsState.disabledVersions.some(
          (disableObj) => disableObj === version.id
        );
        if (!isDisabled) {
          return version;
        }
      }
    }
    const availableVersions = conversationVersionModels?.filter((obj) => {
      return isSubscribed
        ? obj?.name?.toLowerCase() === currentModelName?.toLowerCase()
        : obj?.name?.toLowerCase() === currentModelName?.toLowerCase() &&
            !obj?.isPro;
    });
    // Iterate over the available versions and return the first non-disabled one
    if (availableVersions) {
      for (const version of availableVersions) {
        const isDisabled = ChatsState.disabledVersions.some(
          (disableObj) => disableObj === version.id
        );
        if (!isDisabled) {
          return version;
        }
      }
    }
    // If no non-disabled version is found, return undefined
    return undefined;
  };

  const handleNewReply = (chatId: string, newReply: string,attachment:string) => {
    const reply: dataReplyType = {
      createdAt: new Date().toISOString(), // Adding a timestamp for the reply
      reply: newReply,
      attachment:attachment&&attachment
    };
    // Dispatch the reply to the Redux store
    dispatch(appendReplyToChatModelMessage({ id: chatId, reply }));
  };

  useEffect(() => {
    if (isFinished && messageData?.id?.length > 0) {
      onModelIsFinished(messageData.version, true);
      if (messageType === MessageType.Regenerate) {
        dispatch(
          setIsRegenerating({
            id: messageData.id,
            isRegernating: false,
          })
        );
        handleNewReply(messageData.id, response,imageGeneration.imageURL); // Add the reply to the replies array
        setIsFinished(false);
      } else {
        const isMessageExist = modelState.find((msg) => msg.id === messageData.id);
        const messageEditsAndResponses = {
          MessageId: messageData.id,
          EditMessageIndex: 0,
          ResponseIndex: 0,
        };
        if (messageType === MessageType.Edit) {
          dispatch(
            setIsEditing({ id: ParentMessageId || "", isEditing: false })
          );
          dispatch(setIsEditingStatus(false));
        }
        if(!isMessageExist){
          const message = {
            id: messageData.id || "",
            parentId: ParentMessageId,
            prompt: prompt,
            isRegernating: false,
            isEditing: false,
            replies: [{ createdAt: new Date().toISOString(), reply: response,attachment:imageGeneration.imageURL}],         
            queryAttachments:attachmentFileUploaded?.type? [{...attachmentFileUploaded}]:[],
            version: selectedModelVersion,
            queryEdits: [],
            messageType: messageType,
            modelName: currentModelName,
          };
  
          // Dispatch the async action to save the new message to the store
          dispatch(addChatModelMessageAsync(message));
      }
        const findMsgObject = modelState.find(
          (msg: any) => msg.id === ParentMessageId
        );

        if (findMsgObject?.queryEdits && findMsgObject?.queryEdits.length > 0) {
          dispatch(
            updateModelEditIndex({
              messageId: ParentMessageId,
              editIndex: findMsgObject?.queryEdits?.length - 1,
            })
          );
        }

        dispatch(addEditAndReplayChatModelAsync(messageEditsAndResponses));
        setIsFinished(false);
      }
      // Clear the response and prompt for the next input
      emptyAttachmentFile();
      setAttachmentFileUploaded({ fileName: "", type: "", canDownload: false, blobUrl: "" });
      setImageGeneration({imageURL:"",messageType:0})
      setResponse("");
      setPrompt("");
      setQuery("")
      setMessageType("");
      dispatch(setParentMessageId(null));
    }
  }, [isFinished, messageData, messageType, currentModelName]);

  const handleModelMessage = useCallback(
    (
      modelName: string,
      modelVersion: string,
      message: string,
      tag: string,
      conversationId: string,
      messageId: string,
      messageType: number
    ) => {
      if (selectedModelVersion === modelVersion)
        setMessageData({ version: modelVersion, id: messageId });
      setMessageType(messageType);
      if (versionName.length > 0) {
        if ( modelName?.toLowerCase() + " " + modelVersion === currentModelName?.toLowerCase() + " " + versionName) {
          if (activeConversationId === conversationId) {
            if(messageType===MessageType.MessageHasImage && modelName === currentModelName) {
              setImageGeneration((prev)=>({...prev,messageType:messageType}))
            }
            if (message === "**/**Finished**/**") {
              if (
                messageType === MessageType.Regenerate ||
                messageType === MessageType.Edit
              ) {
                if (currentObj?.id?.length) {
                  if (currentObj?.parentId !== null)
                    dispatch(updatePlaceOfMessage(currentObj?.parentId));
                  else dispatch(updatePlaceOfMessage(currentObj?.id));
                }
              }
              if (messageData.id && messageType !== MessageType.Regenerate) {
                dispatch(
                  updateModelReplyIndex({
                    messageId: messageData.id,
                    replyIndex: 0,
                  })
                );
                if (ParentMessageId)
                  dispatch(
                    updateModelReplyIndex({
                      messageId: ParentMessageId,
                      replyIndex: 0,
                    })
                  );
              }
              if(messageType!== MessageType.WebSearch)
                     setIsFinished(true);
            } else {
              if (message != null) {
                if(messageType === MessageType.GenerateImage && message.length > 0){
                  setImageGeneration((prev)=>({...prev,imageURL: getBaseUrl(message)}))
                }
                else if (message !== "&image&" &&messageType!== MessageType.WebSearch) {
                setResponse((prev) => (prev ? prev + message : message));
                }
                }
              }
              // setIsFinished(false);
            }
          }
        }
    },
    [versionName, currentObj, activeConversationId]
  );

  const setupSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("SendModelMessage", handleModelMessage);
    return () => {
      connection.off("SendModelMessage", handleModelMessage);
    };
  }, [handleModelMessage]);

  useEffect(() => {
    const cleanup = setupSignalRConnection();
    return () => {
      cleanup();
    };
  }, [setupSignalRConnection]);

    // signalR to replace old image url with new AzureImage url
    const handleReplaceImageURL = useCallback(
      (
        messageId: string,
        responseId: string,
        oldImageUrl: string,
        newImageUrl: string
      ) => {
        dispatch(replaceImageURL({messageId,oldImageUrl,newImageUrl}))
      },
      []
    );

    const replaceURLImageSignalRConnection = useCallback(() => {
      const connection = SignalRService.getInstance().connection;
      connection.on("ReplaceOldImageUrl", handleReplaceImageURL);
      return () => {
        connection.off("ReplaceOldImageUrl", handleReplaceImageURL);
      };
    }, [handleModelMessage]);

    useEffect(() => {
      const cleanup = replaceURLImageSignalRConnection();
      return () => {
        cleanup();
      };
    }, [replaceURLImageSignalRConnection]);

  // get selected version from dropdown version component
  const setVersionModel = (version: string) => {
    setSelectedModelVersion(version);
  };

  const handleAutoScroll = () => {
    if (scrollDevRef.current && !isUserInteracted[index]) {
        scrollDevRef.current?.scrollIntoView({
          behavior: 'smooth', 
          block: 'end',
        });
    }
  }
    
  useEffect(() => {
    handleAutoScroll();
  }, [response,imageGeneration?.messageType]);

  const stopAutoScroll = (chatIndex: number) => {
    if(id || (!User.IsAuthenticated && !newConversation)){
      dispatch(setUserInteracted({ index: chatIndex, value: true }));
    }
  };
 
  // handel select company name
  const handleOptionClick = (value: number, company: string) => {
    let modelName = modelNames[value];
    if (isFullWidth.length > 0) {
      handleSetFullWidthModal(`${modelName}${index}`);
    }
    setCurrentModelName(modelName);
    setCompany(company);

    dispatch(conversationsActions.setIsConHistoryClicked(false));
    const newSelectedOptions = [...selectedOptionsStore];
    newSelectedOptions[index] = modelName;
    const updatedOptions = newSelectedOptions.slice(0, selectedColumns);
    dispatch(
      getChatsOpen({
        chatsNum: selectedColumns,
        selectedOptions: updatedOptions,
      })
    );
    setDropdownOpen(false);
    dispatch(setCanSetActiveModels(true));
  };

  const areAllVersionsDisabled = (modelName: string) => {
    const modelVersions = conversationVersionModels?.filter((version) =>
      page === "Landing-page"
        ? version.name.toLowerCase() === modelName.toLowerCase() &&
          version.allowAnnonymous
        : isSubscribed
        ? version.name.toLowerCase() === modelName.toLowerCase()
        : version.name.toLowerCase() === modelName.toLowerCase() &&
          !version.isPro
    );
    // Return true if the model has no versions or all versions are disabled
    return (
      !modelVersions?.length ||
      modelVersions.every((version) =>
        disabledVersions.includes(version.id)
      )
    );
  };

  const HandleSetNewPrompt = (prompt: string) => {
    setPrompt(prompt);
  };

  const filteredMessages = modelState.filter((e: ChatModelState) => {
    return e.version === selectedModelVersion && (e.parentId === null || e.parentId === undefined);
  });

  let numOfChatsOpen = ChatsState.chatsNum;
  let fullWidth =
  isFullWidth === `${currentModelName}${index}`
    ? "full-width"
    : isFullWidth !== "" && isFullWidth !== `${currentModelName}${index}`
    ? "d-none"
    : "";

  const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
  };

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);
  
// Handle slider swaps
const handleTouchStart = (e: any) => {
  const touch = e.touches[0];
  setStartPoint({ x: touch.clientX, y: touch.clientY });
};

const handleTouchMove = (e: any) => {
  const touch = e.touches[0];
  setEndPoint({ x: touch.clientX, y: touch.clientY });
};

const handleTouchEnd = () => {
  const diffX = startPoint.x - endPoint.x;
  const diffY = startPoint.y - endPoint.y;

  if (Math.abs(diffX) > TouchToleranceX && Math.abs(diffY) < TouchToleranceY && !maximizedChat?.versionId) {
    if (diffX > 0) {
      if (index < ChatsState.chatsNum - 1) {
        setActiveChat(index + 1);
      } else {
        setActiveChat(0);
      }
    } else {
      if (index > 0) {
        setActiveChat(index - 1);
      } else {
        setActiveChat(ChatsState.chatsNum - 1);
      }
    }
  }

  // Reset values after touch ends
  setStartPoint({ x: 0, y: 0 });
  setEndPoint({ x: 0, y: 0 });
};
useEffect(()=>{
  if(prompt?.length>0 &&!response){
    setPrompt("")
  }
},[id])
return (
    <>
      <div
        className={`modelContainer column-${numOfChatsOpen} ${!isActiveChat && !isFullWidth ? "not-active" : ""}
        ${numOfChatsOpen === 1 && "h-100"}
         ${currentModelName?.toLowerCase()} ${fullWidth} ${
          numOfChatsOpen === 2 || numOfChatsOpen === 1
            ? "col-12"
            : numOfChatsOpen === 4
            ? "col-6"
            : "col-4"
        }`}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="model">
          <div className="modelHeader d-flex align-items-center justify-content-between ">
            <div className="d-flex gap-3">
              <Dropdown
                className="customDropdown h-100"
                autoClose="outside"
                show={dropdownOpen}
                ref={dropdownRef}
              >
                <Dropdown.Toggle
                  className={`dropdownHeader ${dropdownOpen ? "open" : ""}`}
                  as="div"
                  onClick={toggleDropdown}
                >
                  {company}
                  <ArrowDown className="custom-icon-stroke"/>
                </Dropdown.Toggle>

                {dropdownOpen && (
                  <Dropdown.Menu className="dropdownList pt-0 pb-0">
                    <div className="dropContainer">
                      {ModelsCompany.map((c, index) => {
                        const isCompanyDisabled = areAllVersionsDisabled(
                          modelNames[index]
                        );
                        const isOpenAIEnabled = !areAllVersionsDisabled("openai");
                        const isGoogleEnabled = !areAllVersionsDisabled("google");
                        const isImageDisabled =
                        isGenerateImage &&
                        c.toLowerCase() !== "openai" &&
                        c.toLowerCase() !== "google";

                      const isDropdownEnabled =
                        (c.toLowerCase() === "openai" && isOpenAIEnabled) ||
                        (c.toLowerCase() === "google" && isGoogleEnabled) ||
                        (!isImageDisabled && !isCompanyDisabled);
                        if (isCompanyDisabled) return null; // Skip rendering if company is disabled

                        return (
                          <Dropdown.Item
                            key={index}
                            disabled={!isDropdownEnabled}
                            className={`dropdownItem  ${
                              isCompanyDisabled ? "d-none" : ""
                            }  ${
                              company === ModelsCompany[index] ? "selected" : ""
                            }${!isDropdownEnabled ? "disable-company" : ""}`}
                            onClick={() => handleOptionClick(index, c)}
                          >
                            {c}
                          </Dropdown.Item>
                        );
                      })}
                    </div>
                  </Dropdown.Menu>
                )}
              </Dropdown>
              <ReturnVersionModel
                page={page}
                index={index}
                modelName={currentModelName?.toLowerCase()}
                companyName={company}
                defaultNameVersion={
                  defaultVersion || (id ? "" : firstObjInChatModel?.id)
                }
                setVersionModel={setVersionModel}
                lastActiveVersion={lastActiveVersion}
                annonyVersion={
                  defaultAnnonyVersion || ( (activeConversationId ? "" : firstObjInChatModelInAnnon?.id))
                }
              />
            </div>
            <Box className={`${selectedColumns === 1 && "d-none"}`} 
            sx={miniMaxContainerStyle}
            onMouseEnter={() => setHoverExpandChat(true)}
            onMouseLeave={() => setHoverExpandChat(false)}
            >
              {isFullWidth === `${currentModelName}${index}` ? (
                <div className=" c-pointer" onClick={() => miniChat()}>
                    <RemoveOutlined/>
                </div>
              ) : (
                <div className=" c-pointer" onClick={() => handleSetFullWidthModal(`${currentModelName}${index}`)}>
                  <ExpandIcon/>
                </div>
              )}
              {hoverExpandChat &&(

              <Box sx={minMaxToolTipHoverStyleContainer}>
                <Typography sx={{
                  color: "var(--A_font-color48)",
                  fontFamily: "Inter",
                  fontSize: "11px",
                  fontStyle: "normal",
                  fontWeight: 500,
                }}>
                  {maximizedChat?.versionId ? "Minimize model" : "Expand model"}
                </Typography>
              </Box>
              )}
              
            </Box>
          </div>
          <div className={`modelChat columns-${selectedColumns} ${ChatsState.displayConAtBottom && 'displayConAtBottom'}`}
            onWheel={() => stopAutoScroll(index)}>
            {(newConversation && !id ) || (filteredMessages.length === 0 && prompt.length === 0) ? (
              <div className="new-conversation-message d-flex align-items-center gap-2">
                <img
                  className={`${currentModelName?.toLowerCase()}-styles-newCon-img`}
                />
                <p className="new-conversation-text mb-0">Hi!</p>
              </div>
            ) : null}
            {Messages &&
              Messages
                ?.filter((e: ChatModelState) => {
                  return (
                    e.modelName?.toLowerCase()+" "+ e.version ===currentModelName?.toLowerCase()+" "+selectedModelVersion && (e.parentId === null || e.parentId === undefined)
                  );
                }).map((e: ChatModelState, index: number) => {
                  return (
                    <div key={index} className="user-question">
                      <UserQuestion
                        messageId={e.id}
                        editMessageId={messageData.id}
                        attachmentFile={e.queryAttachments[0]}
                        setQuery={HandleSetNewPrompt}
                        modelName={currentModelName?.toLowerCase()}
                        response={response}
                        isFinished={isFinished}
                      />
                    </div>
                  );
                })}
            {prompt && (
              <div className="user-question">
                  <StreamingUserQuestion
                    prompt={prompt}
                    attachmentFile={attachmentFileUploaded}
                  />
              </div>
            )}
            {prompt && !response  ? (
              <div className="user-question">
                <ResponseLoading messageType={imageGeneration.messageType} modelName={currentModelName?.toLowerCase()} />
              </div>
            ) : (
              response && (
                <div className="chat-component user-question">
                  <StreamingChatResponse
                    response={response}
                    imageURL={imageGeneration.imageURL}
                    modelName={currentModelName}
                    messageType={imageGeneration.messageType}
                    currentMessageId={messageData.id}
                  />
                </div>
              )
            )}
            <div className="scroll-to-view" ref={scrollDevRef}></div>
          </div>
          {response && maximizedChat === null && (
            <div
              className={`stop-response-Style ${
                darkMode ? "darkBackground" : "lightBackground"
              }`}
            >
              <StopResponse modelName={modelNameFromParent} isStopAll={false} />
            </div>
          )}
        </div>
      </div>
    </>
  );
});

export default ChatModel;
